import React from 'react';
import { List } from 'immutable';

export const responseValueToJsx = (
  responseValue: string | number | string[] | List<string>,
  questionType: string
) => {
  if (questionType === 'FileUpload' && responseValue) {
    return (
      <a href={responseValue as string} target="_blank">
        {responseValue}
      </a>
    );
  }

  if (questionType === 'NonprofitSelector' && responseValue && typeof responseValue !== 'number') {
    const nonprofits =
      typeof responseValue === 'string'
        ? [responseValue]
        : 'toArray' in responseValue
        ? responseValue?.toArray()
        : responseValue;

    return nonprofits.map((nonprofitId) => (
      <p key={nonprofitId}>
        <a
          href={`/organizations/${nonprofitId}`}
          target="_blank"
        >{`${window.location.origin}/organizations/${nonprofitId}`}</a>
      </p>
    ));
  }

  if (typeof responseValue === 'number') {
    return <>{responseValue}</>;
  }

  if (typeof responseValue === 'string') {
    return (
      <>
        {responseValue.split('\n').map((item, key) => (
          <span key={item || key}>
            {item}
            <br />
          </span>
        ))}
      </>
    );
  }

  // Type should be immutable/List at this point
  return <>{responseValue.join(', ')}</>;
};
